import { Alert } from 'reactstrap';

/**
 * A copy opens at the top of the form, above the copied content, so without
 * this the user cannot tell the copy happened at all.
 */
export const CopyBanner = ({ copiedFrom }: { copiedFrom?: string }) => (
    <Alert color='info' className='mb-4'>
        <strong>
            Success! You created a copy
            {copiedFrom ? ` of “${copiedFrom}”` : ''}.
        </strong>{' '}
        Review and update as needed, then click Save to publish. Click Cancel
        to discard this copy.
    </Alert>
);
